import React from 'react';
import BreadcrumbBanner from './BreadcrumbBanner';

function Gallery() {
  // यहाँ 'public/images/' फोल्डर में रखी गई आपकी अपनी इमेजेस का पाथ है
  const photos = [
    { url: "/images/office-chair.jpg", title: "Professional Repairing" },
    { url: "/images/conference-chair.jpg", title: "Premium Leather Upholstery" },
    { url: "/images/bar-chair.jpg", title: "Durable Base & Wheels" },
    { url: "/images/reception-chair.jpg", title: "Expert Polishing & Servicing" },
    { url: "/images/high-boss.jpg", title: "Meeting Room Chair Sets" },
    { url: "/images/service1.jpg", title: "Modern Office Chairs" }
  ];

  return (
    <div>
      <BreadcrumbBanner title="Our Gallery" />
      
      <div className="container my-5">
        <h2 className="text-center mb-5 fw-bold text-primary">Our Work Portfollio</h2>
        
        <div className="row">
          {photos.map((photo, index) => (
            <div className="col-md-4 col-sm-6 mb-4" key={index}>
              <div className="card h-100 shadow-sm border-0 gallery-card">
                <img 
                  src={photo.url} 
                  alt={photo.title} 
                  className="card-img-top img-fluid" 
                  style={{ height: '250px', objectFit: 'cover' }} 
                />
                <div className="card-body text-center">
                  <p className="card-text fw-bold">{photo.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5 alert alert-info">
          💡 These are just a few examples. We provide expert repair services for all types of office and home chairs.
        </div>
        
        <style jsx>{`
          .gallery-card {
            transition: transform 0.3s ease;
          }
          .gallery-card:hover {
            transform: translateY(-5px);
          }
        `}</style>
      </div>
    </div>
  );
}

export default Gallery;